import styled from 'styled-components';
import { FontSize, FontWeight, inputStyle } from 'commons';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
`;

export const Header = styled.header`
  width: 100%;
  padding: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.neutral_700};
`;

export const LogoWrapper = styled.div`
  height: 100%;
  width: 64px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.neutral_100};
  svg {
    width: 100%;
  }
`;

export const Content = styled.div`
  width: 100%;
  max-width: 950px;
  display: flex;
  flex-direction: column;
  padding: 32px;
  margin: 0 auto;
  gap: 12px;
  align-items: center;
  height: 100vh;
  color: ${({ theme }) => theme.neutral_500};
`;

export const Title = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 16px;

  span {
    color: ${({ theme }) => theme.danger_300};
  }
`;

export const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 48px 0 32px;
`;

export const FormSectionContent = styled.div<{
  $direction?: 'column' | 'row';
}>`
  width: 100%;
  display: flex;
  flex-direction: ${({ $direction }) => ($direction ? $direction : 'row')};
  justify-content: ${({ $direction }) =>
    $direction === 'column' ? 'flex-start' : 'space-between'};
  gap: 16px;
`;

export const FormSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const FormColumn = styled.div`
  width: 50%;
  max-width: 435px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const FormRow = styled.div<{ $full?: boolean }>`
  height: 100%;
  width: ${({ $full }) => ($full ? '100%' : 'fit-content')};
  display: flex;
  gap: 16px;
`;

export const Label = styled.label`
  font-size: ${FontSize.font12};
  font-weight: ${FontWeight.regular};

  span {
    color: ${({ theme }) => theme.danger_300};
  }
`;

export const InputWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  gap: 4px;
`;

export const RadioWrapper = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  gap: 8px;

  input[type='radio'] {
    width: 20px;
    height: 20px;
  }
`;

export const UploadWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const TextAreaWrapper = styled(InputWrapper)`
  width: 100%;

  textarea {
    height: 68px;
    border: 1px solid ${({ theme }) => theme.neutral_500};
    border-radius: 8px;
    padding: 12px 16px;
    font-size: ${FontSize.font12};
    font-weight: ${inputStyle.fontWeight};
    resize: none;

    &::placeholder {
      opacity: ${inputStyle.placeholderOpacity};
    }
  }
`;

export const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;
